
interface ISearch extends ng.resource.IResource<ISearch> {
    Id: number;
}
export interface ISearchResource extends ng.resource.IResourceClass<ISearch> {
    create(): ISearch;
}
export function search_factory($resource: ng.resource.IResourceService, MyConstant): ISearchResource {
    "ngInject";
    return <ISearchResource>$resource(MyConstant.ApiUrl + 'search', {
    }, {
            get: {
                method: 'GET',
                url: `${MyConstant.ApiUrl}ECBTempGeneral/SearchProducts?VendorId=Null&CategoryId=null&ProductTypeId=null&SortField='Meta_DateModifed'&SortAsc=false&RowPerPage=10&PageNumber=1&JustUsedProduct=false&JustAvailableProducts=false&FilterText=':FilterText'&SearchInName=true&SearchInAttr=true&SearchInBrand=false&SearchInCat=true`,
                cancellable:true
            },

        });
}



// WEBPACK FOOTER //
// ./src/factories/search/search.ts